// constants/clients.js
// La fuente real de clientes llega desde /loadInitialData.

export const CLIENTS = [];

const MULTI_TLDS = ['com.ar', 'net.ar', 'org.ar', 'gov.ar', 'edu.ar'];

const toLower = (s = '') => String(s).toLowerCase();
const stripTrailingSlash = (u = '') => String(u).replace(/\/+$/, '');

const isValidClient = (client) => (
  client
  && typeof client.name === 'string'
  && typeof client.url === 'string'
  && (client.clientToken || client.clientId)
);

const normalizeClients = (clients = []) => (
  Array.isArray(clients) ? clients.filter(isValidClient) : []
);

let runtimeClients = [];

export function setRuntimeClients(clients = []) {
  runtimeClients = normalizeClients(clients);
}

export function getRuntimeClients() {
  return runtimeClients;
}

export function getAvailableClients() {
  return runtimeClients.length ? runtimeClients : CLIENTS;
}

const normalizeHost = (host = '') => {
  const noPort = String(host).split(':')[0];
  return toLower(noPort).replace(/^www\./, '');
};

const hostFromUrl = (urlStr = '') => {
  try {
    return normalizeHost(new URL(urlStr).host);
  } catch {
    return '';
  }
};

export function getSiteKeyFromHost(host = '') {
  const h = normalizeHost(host);
  if (!h) return null;

  const parts = h.split('.');
  if (parts.length === 1) return parts[0];

  const tld2 = parts.slice(-2).join('.');
  const endsWithMulti = MULTI_TLDS.some((t) => tld2 === t);
  const baseCount = endsWithMulti ? 3 : 2;

  if (parts.length > baseCount) {
    return parts[0];
  }

  return parts[parts.length - baseCount];
}

export function getSiteKey(origin = (typeof window !== 'undefined' ? window.location.origin : '')) {
  try {
    const host = new URL(origin).host;
    return getSiteKeyFromHost(host);
  } catch {
    return null;
  }
}

export function getClientConfig(origin = (typeof window !== 'undefined' ? window.location.origin : '')) {
  const availableClients = getAvailableClients();
  const siteKey = getSiteKey(origin);

  if (siteKey) {
    const byName = availableClients.find((c) => toLower(c.name) === toLower(siteKey));
    if (byName) return byName;
  }

  let currentHost = '';
  try {
    currentHost = normalizeHost(new URL(origin).host);
  } catch {
    currentHost = '';
  }

  if (currentHost) {
    const byHost = availableClients.find((c) => hostFromUrl(c.url) === currentHost);
    if (byHost) return byHost;
  }

  const normOriginNoSlash = stripTrailingSlash(toLower(origin)).replace('://www.', '://');
  return (
    availableClients.find((c) => {
      const cNorm = stripTrailingSlash(toLower(c.url)).replace('://www.', '://');
      return normOriginNoSlash.startsWith(cNorm);
    }) || null
  );
}

export default CLIENTS;
